<template>
  <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
    <button @click="$emit('updateValues', { 'view': 'listar_1' });"
      class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none ml-auto">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="inline-block w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
      </svg>
      <span class="ml-3">Volver</span>
    </button>
  </div>
  <div class="grid grid-cols-6 gap-6">
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="rp" class="block text-sm font-medium text-gray-700">RP<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="rp" v-model="loadInputs.rp"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="fecha" class="block text-sm font-medium text-gray-700">Fecha <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="date" :disabled="view === ''" id="fecha" v-model="loadInputs.fecha"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo_rubro" class="block text-sm font-medium text-gray-700">Codigo Rubro<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="codigo_rubro" v-model="loadInputs.id_rubro"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre_rubro" class="block text-sm font-medium text-gray-700">Nombre Rubro<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="nombre_rubro" v-model="loadInputs.nombre_rubro"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo_fuente" class="block text-sm font-medium text-gray-700">Codigo Fuente<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="codigo_fuente" v-model="loadInputs.codigo_fuente"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre_fuente" class="block text-sm font-medium text-gray-700">Nombre Fuente Macro<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="nombre_fuente" v-model="loadInputs.nombre_fuente_macro"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="nombre_fuente" class="block text-sm font-medium text-gray-700">Nombre Fuente <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="nombre_fuente" v-model="loadInputs.nombre_fuente"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo_contrato" class="block text-sm font-medium text-gray-700">Codigo Contrato<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="codigo_contrato" v-model="loadInputs.codigo_contrato"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="concepto_contrato" class="block text-sm font-medium text-gray-700">Concepto Contrato<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="concepto_contrato" v-model="loadInputs.concepto_contrato"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="codigo_beneficiario" class="block text-sm font-medium text-gray-700">Codigo Beneficiario <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="codigo_beneficiario" v-model="loadInputs.codigo_beneficiario"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="beneficiario" class="block text-sm font-medium text-gray-700">Beneficiario <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="beneficiario" v-model="loadInputs.beneficiario"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="valor" class="block text-sm font-medium text-gray-700">Valor Contrato <span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="valor" v-model="loadInputs.valor"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="secretaria_ejecutora" class="block text-sm font-medium text-gray-700">Ordenador del Gasto<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="secretaria_ejecutora" v-model="loadInputs.secretaria_ejecutora"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
    <div class="col-span-6 sm:col-span-3 lg:col-span-2">
      <label for="secretaria_ejecutora" class="block text-sm font-medium text-gray-700">Macro Ejecutor<span
          :class="view === '' ? 'hidden' : 'font-bold text-red-700'">(*)</span></label>
      <input type="text" id="secretaria_ejecutora" v-model="loadInputs.nombre_macro_ejecutor"
        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
    </div>
  </div>
  <div id="btnUpdateManualPasivo" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
    <button type="button" @click="handleUpdate(loadInputs)" v-text="view === 'crear' ? 'Guardar' : 'Actualizar Datos'"
      class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
    </button>
  </div>
</template>
<script>
import {
  generateTextError,
  separateNumberByCommaInput,
  swal,
  useAPIRest,
  verifyHttpCode,
} from "@/common/constants";
import { nextTick, ref, watch } from "vue";

/**
 * Componente de Vue.js para crear y actualizar provisiones
 * @name ProvisionesCrearActualizarComponent
 * @module ProvisionesCrearActualizarComponent
 */

export default {
  name: 'ReservasActualizaManualComponent',
  props: ['view', 'paginate', 'loadData', 'entity', 'customListData', 'authToken', 'customUpdateLoadData', 'customUpdateValueData', 'collectionReservas', 'data', 'mainListCollectionData', 'customUpdateCollectionData'],
  emits: ["updateValues", "customSaveData"],

  async setup(props) {
    /**
     * Función asincrónica que guarda los datos en la API.
     * @async
     * @function
     * @name customSaveData
     * @returns {Promise<void>} - Promesa que no devuelve ningún valor.
     */
    const loadInputs = ref({
      id_rubro: '',
      nombre_rubro: '',
      codigo_fuente: '',
      nombre_fuente_macro: '',
      nombre_fuente: '',
      codigo_contrato: '',
      concepto_contrato: '',
      codigo_beneficiario: '',
      beneficiario: '',
      valor: '',
      secretaria_ejecutora: '',
      nombre_macro_ejecutor: '',
    });
    const queryDataToUpdate = async () => {
      const res = await useAPIRest(process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_FINDONE.replace(':id', props.data.id), 'GET', props.authToken, undefined)
        loadInputs.value.rp                    = res.rp,
        loadInputs.value.fecha                 = res.fecha
        loadInputs.value.id_rubro              = res.id_rubro
        loadInputs.value.nombre_rubro          = res.nombre_rubro,
        loadInputs.value.codigo_fuente         = res.codigo_fuente,
        loadInputs.value.nombre_fuente_macro   = res.nombre_fuente_macro
        loadInputs.value.nombre_fuente         = res.nombre_fuente,
        loadInputs.value.codigo_contrato       = res.codigo_contrato,
        loadInputs.value.concepto_contrato     = res.concepto_contrato
        loadInputs.value.codigo_beneficiario   = res.codigo_beneficiario,
        loadInputs.value.beneficiario          = res.beneficiario,
        loadInputs.value.valor                 = res.valor,
        loadInputs.value.secretaria_ejecutora  = res.secretaria_ejecutora
        loadInputs.value.nombre_macro_ejecutor = res.nombre_macro_ejecutor
      }
      watch(() => loadInputs.value.valor, (newValor) => {
        nextTick(() => loadInputs.value.valor = separateNumberByCommaInput(newValor));
      });
    await queryDataToUpdate();

    return {
      loadInputs
    }
  },

  methods: {
    async handleUpdate(loadInputs) {
      await swal.fire({
        title: 'Actualizar Pasivo Exigible',
        icon: 'question',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Aceptar',
        customClass: {
          actions: 'm-0'
        },
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          loadInputs.valor = loadInputs.valor.replaceAll(',','');
          return await useAPIRest(process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_UPDATE_MANUAL.replace(':id', this.data.id), 'POST', this.authToken, loadInputs).then(async resJSON => resJSON);
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then(async (result) => {
        if (result.isConfirmed && result.value !== true) {
          const resJSON = result.value;
          const { statusCode } = resJSON;
          delete resJSON['statusCode'];
          const textoError = generateTextError(resJSON);
          this.mainListCollectionData();
          this.$emit('updateValues', { 'view': 'listar_1' });
          if (verifyHttpCode(statusCode, 'success')) {
            await swal.fire('Actualizacion realizada de manera exitosa', '', 'success');
          } else {
            const errorWhitoutFormat = textoError.replace(/<\/?div>/g, '');
            const lineas = errorWhitoutFormat.split('- ')
            const textErrorCorregido = lineas.join('<br>')
            await swal.fire({
              title: 'No se ha podido realizar la Actualización',
              icon: 'error',
              focusConfirm: true,
              html: textErrorCorregido
            })
          }
        }
      })
    }
  }
}
</script>